<app-header></app-header>
<div class="tracker-detail pt0">
    <div class="headerbanner" *ngIf="!isMapDirection">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <app-map></app-map>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="innercard mb50">
                    <div *ngIf="!isDisplayCheckInNotAllowed;else load_else">
                        <p class="font24 clrblue mb10 center lh30">
                            <span translate>lblThankYou</span>,
                            <span translate>lblCheckInComplete</span>
                        </p>
                        <p class="font18 center pt-3"> 
                            <span translate>lblReadyForYourVisit</span>
                            <span class="ml-1">{{checkInDateTime | date: 'shortDate' }}</span>
                        </p>
                    </div>
                    <ng-template #load_else translate>
                        <p class="font24 clrblue mb10 center lh30" translate>lblNotAllowedToCheckin</p>
                        <p class="font18 mb10 center" translate>{{errorMessage}}</p>
                        <p class="font18 center" translate>lblCallDealerOrTrackStatus</p>
                    </ng-template>

                    <div class="mt30">
                        <ul class="lst1 row">
                            <li class="lastchild pb-2 p-0">
                                <app-dealer-address></app-dealer-address>
                            </li>
                            <li class="col p-0">
                                <a href="tel:{{dealerPhone}}" class="center blk py-3" translate
                                    (click)="CallDealerLogEntry()">
                                    <span class="circle"><em class="fa fa-phone clrlightblue"></em></span>
                                    lblCallDealership
                                </a>
                            </li>
                            <li *ngIf="isMapDirection" class="border-left col p-0">
                                <a href="javascript:void(0);" class="center blk py-3" translate
                                    (click)="openMapDirection();">
                                    <span class="circle"><em class="fa fa-map clrblue"></em></span>
                                    lblDealerDirection<em class="fas fa-angle-right ml5 font16
                                    txtblue"></em>
                                </a>
                            </li>
                            <li class="border-left col p-0" *ngIf="!isDisplayCheckInNotAllowed">
                                <a href="{{statusTrackerLink}}" class="center blk py-3"
                                    onclick="javascript:window.open(this.href, '_blank'); return false; " 
                                    [class.disabled]="!statusTrackerLink" translate>
                                    <span class="circle "><em
                                            class="fa fa-tools clrlightred "></em></span>lblTrackService
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<app-footer-site-info></app-footer-site-info>